import { useEffect, useRef } from 'react'
import { useMapsLibrary } from '@vis.gl/react-google-maps'
import { toSelectedPlace } from '../utils/parsePolishAddress'

export default function AddressSearchBar({ placeholder = 'Podaj adres', onPlaceSelect }) {
	const inputRef = useRef(null)
	const placesLib = useMapsLibrary('places')

	useEffect(() => {
		if (!window.google || !inputRef.current || !placesLib) return
		if (!window.google.maps?.places?.PlaceAutocompleteElement) {
			console.error('PlaceAutocompleteElement is unavailable in this Maps JS channel. Try version="beta".')
			return
		}

		const autocomplete = new window.google.maps.places.PlaceAutocompleteElement()
		autocomplete.placeholder = placeholder
		autocomplete.componentRestrictions = { country: ['pl'] }
		autocomplete.types = ['address']
		autocomplete.style.width = '100%'
		autocomplete.style.display = 'block'

		inputRef.current.innerHTML = ''
		inputRef.current.appendChild(autocomplete)

		const handlePlaceChange = async ({ placePrediction }) => {
			if (!placePrediction) return

			const place = placePrediction.toPlace()
			await place.fetchFields({
				fields: ['id', 'formattedAddress', 'location', 'addressComponents'],
			})

			if (!place.location) {
				console.error('No geometry returned for selected place')
				return
			}

			const result = toSelectedPlace(place)
			if (result && typeof onPlaceSelect === 'function') {
				onPlaceSelect(result)
			}
		}

		autocomplete.addEventListener('gmp-select', handlePlaceChange)

		return () => {
			autocomplete.removeEventListener('gmp-select', handlePlaceChange)
		}
	}, [placesLib, onPlaceSelect, placeholder])

	return (
		<div ref={inputRef} />
	)
}
